module.exports = __webpack_public_path__ + "static/media/ic_proyectos_maritimo_pin_seleccionado.a930e8a6.svg";